import { getFakeTokenHeader } from '@/utils/permissions-widget/token';

import Constants from '@/constants';

import {
  type ClientOptions as DefaultClientOptions,
  type Config,
  mergeHeaders,
} from '@/_generated/api-clients/content/client';
import type { ClientOptions } from '@/_generated/api-clients/content/types.gen';

/**
 * ## Content API client config.
 *
 * Used by the generated Content API client.
 */
export const createClientConfigContent = (
  config?: Config<DefaultClientOptions & ClientOptions>,
): Config<Required<DefaultClientOptions> & ClientOptions> => ({
  ...config,
  baseUrl: Constants.PATHWAY_API_URL,
  headers: mergeHeaders(config?.headers, getFakeTokenHeader()),
  credentials: 'include',
  auth: async () => {
    const { getApiToken } = await import('@/utils/auth');
    return getApiToken();
  },
});
